import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";

export interface DateRangeApi {
  range: ReadOnlyStore<{ start: string | null; end: string | null }>;
  setRange(start: string | null, end: string | null): void;
}

export function createDateRangeApi(): DateRangeApi {
  const store = createStore<{ start: string | null; end: string | null }>({
    start: null,
    end: null,
  });
  return {
    range: store.store,
    setRange: (start, end) => store.set({ start, end }),
  };
}
